
// Route scaling and profile keys
export const PROFILE_CONFIG = {
    flag_10u_5v5: { routeDepthScale: 0.60, routeWidthScale: 0.85, throwProfileKey: "flag_10u", speedProfileKey: "flag_10u", formationSetKey: "flag_5v5" },
    flag_10u_6v6: { routeDepthScale: 0.60, routeWidthScale: 0.85, throwProfileKey: "flag_10u", speedProfileKey: "flag_10u", formationSetKey: "flag_6v6" },
    flag_10u_7v7: { routeDepthScale: 0.60, routeWidthScale: 0.85, throwProfileKey: "flag_10u", speedProfileKey: "flag_10u", formationSetKey: "flag_7v7" },

    flag_12u_5v5: { routeDepthScale: 0.85, routeWidthScale: 0.90, throwProfileKey: "flag_12u", speedProfileKey: "flag_12u", formationSetKey: "flag_5v5" },
    flag_12u_6v6: { routeDepthScale: 0.85, routeWidthScale: 0.90, throwProfileKey: "flag_12u", speedProfileKey: "flag_12u", formationSetKey: "flag_6v6" },
    flag_12u_7v7: { routeDepthScale: 0.85, routeWidthScale: 0.90, throwProfileKey: "flag_12u", speedProfileKey: "flag_12u", formationSetKey: "flag_7v7" },

    flag_13plus_5v5: { routeDepthScale: 1.10, routeWidthScale: 0.95, throwProfileKey: "flag_13plus", speedProfileKey: "flag_13plus", formationSetKey: "flag_5v5" },
    flag_13plus_6v6: { routeDepthScale: 1.10, routeWidthScale: 0.95, throwProfileKey: "flag_13plus", speedProfileKey: "flag_13plus", formationSetKey: "flag_6v6" },
    flag_13plus_7v7: { routeDepthScale: 1.10, routeWidthScale: 0.95, throwProfileKey: "flag_13plus", speedProfileKey: "flag_13plus", formationSetKey: "flag_7v7" },

    flag_adult_5v5: { routeDepthScale: 1.20, routeWidthScale: 1.00, throwProfileKey: "flag_adult", speedProfileKey: "flag_adult", formationSetKey: "flag_5v5" },
    flag_adult_6v6: { routeDepthScale: 1.20, routeWidthScale: 1.00, throwProfileKey: "flag_adult", speedProfileKey: "flag_adult", formationSetKey: "flag_6v6" },
    flag_adult_7v7: { routeDepthScale: 1.20, routeWidthScale: 1.00, throwProfileKey: "flag_adult", speedProfileKey: "flag_adult", formationSetKey: "flag_7v7" },

    // Tackle/Standard levels (no format needed effectively, or could default)
    pro: { routeDepthScale: 1.25, routeWidthScale: 1.05, throwProfileKey: "pro", speedProfileKey: "pro", formationSetKey: null },
    college: { routeDepthScale: 1.15, routeWidthScale: 1.00, throwProfileKey: "college", speedProfileKey: "college", formationSetKey: null },
    hs: { routeDepthScale: 1.00, routeWidthScale: 1.00, throwProfileKey: "hs", speedProfileKey: "hs", formationSetKey: null },
    peewee: { routeDepthScale: 0.70, routeWidthScale: 0.90, throwProfileKey: "peewee", speedProfileKey: "peewee", formationSetKey: null },
};

// Speed profiles (40-yard dash time in seconds)
export const SPEED_PROFILE_40S = {
    flag_10u: { QB: 5.85, RB: 5.75, WR: 5.75, SL: 5.80, C: 6.05, DEF: 5.85 },
    flag_12u: { QB: 5.55, RB: 5.45, WR: 5.45, SL: 5.50, C: 5.75, DEF: 5.55 },
    flag_13plus: { QB: 5.15, RB: 5.05, WR: 5.05, SL: 5.10, C: 5.35, DEF: 5.15 },
    flag_adult: { QB: 5.05, RB: 4.95, WR: 4.95, SL: 5.00, C: 5.20, DEF: 5.05 },

    hs: { QB: 5.10, RB: 4.95, WR: 4.90, SL: 4.95, C: 5.25, DEF: 5.00 },
    college: { QB: 4.95, RB: 4.75, WR: 4.70, SL: 4.75, C: 5.05, DEF: 4.85 },
    pro: { QB: 4.85, RB: 4.55, WR: 4.50, SL: 4.55, C: 4.95, DEF: 4.65 },
    peewee: { QB: 6.10, RB: 5.95, WR: 5.95, SL: 6.00, C: 6.30, DEF: 6.10 },
};

export const buildProfileKey = (level, flagAge, format) => {
    if (!level) return 'flag_12u_6v6'; // super default
    let lvl = level.toLowerCase().replace(/ /g, '_').replace(/-/g, '_');

    // Handle legacy "Flag" with separate age input
    if (lvl === 'flag') {
        let age = (flagAge || '12U').toLowerCase().replace('+', 'plus');
        lvl = `flag_${age}`;
    }

    // If it is a specific flag level (e.g. flag_12u or constructed above), append format
    if (lvl.startsWith('flag_')) {
        let fmt = (format || '6v6').toLowerCase();
        return `${lvl}_${fmt}`;
    }

    // For tackle levels (pro, college, hs, peewee), return simple key
    return lvl;
};

export const getProfileConfig = (profileKey) => {
    return PROFILE_CONFIG[profileKey] || PROFILE_CONFIG['flag_12u_6v6'];
};

export const normalizeProfile = (profile) => {
    if (!profile || !profile.level) {
        return {
            level: 'Flag',
            flagAge: '12U',
            format: '6v6',
            profileKey: 'flag_12u_6v6',
            ...PROFILE_CONFIG['flag_12u_6v6']
        };
    }

    const key = buildProfileKey(profile.level, profile.flagAge, profile.format);
    const config = getProfileConfig(key);

    return {
        ...profile,
        profileKey: key,
        ...config
    };
};
